import { useEffect, useState } from "react";
import { catEstatusProceso } from "./../constant/catEstatusProceso"
export function useEstatusPaqueteValido({ estatus }) {
    const [valido, setValido] = useState(true)
    useEffect(() => {
        const validar = () => {
            if (estatus === catEstatusProceso.BAJA_INACTIVIDAD
                || estatus === catEstatusProceso.FINALIZADO
                || estatus === catEstatusProceso.CANCELADO_CLIENTE
                || estatus === catEstatusProceso.CANECLADO_AGENTE){
                    setValido(false)
                    return null
                }
                setValido(true)
        }
        validar()
    }, [estatus])
    return [valido]
}